/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Sub_TypologyInputs */

const cs_property_sub_typology = /** @type {(inputs: Property_Sub_TypologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typologie`)
};

const en_property_sub_typology = /** @type {(inputs: Property_Sub_TypologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typology`)
};

/**
* | output |
* | --- |
* | "Typology" |
*
* @param {Property_Sub_TypologyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_sub_typology = /** @type {((inputs?: Property_Sub_TypologyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Sub_TypologyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_sub_typology(inputs)
	return cs_property_sub_typology(inputs)
});